import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';

export const styledBackstageDependencyGraphNode = (
  theme: Theme,
): BackstageOverrides['BackstageDependencyGraphNode'] => ({
  node: {
    '& rect.primary': {
      fill: `${theme.palette.primary.main} !important`,
      stroke: `${theme.palette.primary.main} !important`,
    },
    '& text.primary, svg.primary': {
      fill: `${theme.palette.primary.contrastText} !important`,
    },
  },
});
